import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "absentButton", "absentHidden", "absentIcon", "absentX",
    "lateButton", "lateHidden", "lateX", "lateButtonText",
    "latenessForm", "minutesInput", "reasonInput",
    "statusTag"
  ]
  
  static values = {
    studentId: String,
    initiallyOpen: Boolean
  }
  
  connect() {
    console.log("Attendance-lateness controller connected for student", this.studentIdValue)
    
    // Initialize state based on existing data
    if (this.absentHiddenTarget.value === "0" && this.lateHiddenTarget.value === "0") {
      // Check if there's existing lateness or absence based on button styling
      if (this.lateButtonTarget.classList.contains('is-on')) {
        this.lateHiddenTarget.value = "1"
      }
      if (this.absentButtonTarget.classList.contains('is-on')) {
        this.absentHiddenTarget.value = "1"
      }
    }

    if (this.hasInitiallyOpenValue && this.initiallyOpenValue) {
      this.setLate()
    } else if (this.latenessFormTarget && !this.latenessFormTarget.classList.contains('hidden')) {
      this.latenessFormTarget.classList.add('hidden')
    }
  }
  
  toggleAbsent(event) {
    event.preventDefault()
    
    const currentlyAbsent = this.absentHiddenTarget.value === "1"
    
    if (currentlyAbsent) {
      // Cancel absence
      this.clearAbsence()
    } else {
      // Mark as absent
      this.setAbsent()
      // Clear lateness
      this.clearLateness()
      // Close all other lateness forms
      this.closeOtherLatenessForms()
    }
  }
  
  toggleLate(event) {
    event.preventDefault()
    
    const currentlyLate = this.lateHiddenTarget.value === "1"
    const formVisible = !this.latenessFormTarget.classList.contains('hidden')
    
    if (currentlyLate && formVisible) {
      // Form is open, just close it without clearing the state
      this.latenessFormTarget.classList.add('hidden')
    } else if (currentlyLate && !formVisible) {
      // Form is closed, open it
      this.latenessFormTarget.classList.remove('hidden')
      // Close all other lateness forms
      this.closeOtherLatenessForms()
    } else {
      // Not currently late, mark as late
      this.setLate()
      // Clear absence
      this.clearAbsence()
      // Close all other lateness forms
      this.closeOtherLatenessForms()
    }
  }
  
  clearLatenessClick(event) {
    event.preventDefault()
    event.stopPropagation()
    this.clearLateness()
  }
  
  updateDuration(event) {
    const minutes = parseInt(this.minutesInputTarget.value) || 0
    const text = minutes > 0 ? `En retard (${minutes}min)` : "En retard"
    this.lateButtonTextTarget.textContent = text
    
    // Also update status tag if visible
    if (!this.statusTagTarget.classList.contains('hidden')) {
      const statusSpan = this.statusTagTarget.querySelector('span')
      if (statusSpan && statusSpan.classList.contains('ds-chip--warning')) {
        statusSpan.textContent = minutes > 0 ? `En retard (${minutes}min)` : "En retard"
      }
    }
  }
  
  setAbsent() {
    this.absentHiddenTarget.value = "1"
    
    // Update button style to selected (DS)
    this.absentButtonTarget.classList.add('is-on')

    // Show X icon, hide regular icon
    this.absentIconTarget.classList.add('hidden')
    this.absentXTarget.classList.remove('hidden')

    // Show status tag
    this.statusTagTarget.classList.remove('hidden')
    this.statusTagTarget.innerHTML = '<span class="ds-chip ds-chip--danger ds-chip--sm">Absent</span>'
  }
  
  clearAbsence() {
    this.absentHiddenTarget.value = "0"
    
    // Update button style to unselected (DS)
    this.absentButtonTarget.classList.remove('is-on')
    
    // Hide X icon, show regular icon
    this.absentIconTarget.classList.remove('hidden')
    this.absentXTarget.classList.add('hidden')
    
    // Hide status tag if no lateness
    if (this.lateHiddenTarget.value === "0") {
      this.statusTagTarget.classList.add('hidden')
    }
  }
  
  setLate() {
    this.lateHiddenTarget.value = "1"
    
    // Update button style to selected (DS)
    this.lateButtonTarget.classList.add('is-on')
    
    // Show X icon
    this.lateXTarget.classList.remove('hidden')
    
    // Show lateness form
    this.latenessFormTarget.classList.remove('hidden')
    
    // Show status tag
    this.statusTagTarget.classList.remove('hidden')
    const minutes = parseInt(this.minutesInputTarget.value) || 0
    const text = minutes > 0 ? `En retard (${minutes}min)` : "En retard"
    this.statusTagTarget.innerHTML = `<span class="ds-chip ds-chip--warning ds-chip--sm">${text}</span>`
  }
  
  clearLateness() {
    this.lateHiddenTarget.value = "0"
    
    // Update button style to unselected (DS)
    this.lateButtonTarget.classList.remove('is-on')
    
    // Hide X icon
    this.lateXTarget.classList.add('hidden')
    
    // Hide lateness form
    this.latenessFormTarget.classList.add('hidden')
    
    // Reset button text
    this.lateButtonTextTarget.textContent = "En retard"
    
    // Clear form inputs
    this.minutesInputTarget.value = "0"
    this.reasonInputTarget.value = ""
    
    // Hide status tag if no absence
    if (this.absentHiddenTarget.value === "0") {
      this.statusTagTarget.classList.add('hidden')
    }
  }
  
  closeOtherLatenessForms() {
    // Find all attendance-lateness controllers in the page
    const allControllers = this.application.controllers.filter(c => 
      c.identifier === "attendance-lateness" && c.studentIdValue !== this.studentIdValue
    )
    
    allControllers.forEach(controller => {
      if (controller.lateHiddenTarget.value === "1") {
        // Only close the form, don't change the state
        controller.latenessFormTarget.classList.add('hidden')
      }
    })
  }
}

